import * as React from "react";
import Typography from "@mui/material/Typography";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
// import ListItemText from '@mui/material/ListItemText';
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import CircularProgress from "@mui/material/CircularProgress";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import { setUserData } from "../redux/action";
import ChargesSummary from "../components/ChargesSummary";
import StripePaymentSection from "../components/StripePaymentSection";


// const products = [
//   {
//     name: 'Adults',
//     price: '9',
//   },
//   {
//     name: 'Kids',
//     price: '3',
//   },
//   {
//     name: 'Infants',
//     price: '6',
//   }
// ];

// const addresses = ['1 MUI Drive', 'Reactville', 'Anytown', '99999', 'USA'];
// const payments = [
//   { name: 'Date', detail: '31-06-2023 13:00PM' }

// ];

export default function Review({
  advancePaymentData,
  loadingAdvanceConfig,
  onStripeReady,
}) {
  const data = useSelector((state) => state.auth?.userdata);
  const { currencySymbol } = useSelector((state) => state.auth) || {};
  const dispatch = useDispatch();

  React.useEffect(() => {
    dispatch(setUserData({}));
  }, [dispatch]);

  const totalGuests =
    (Number(data?.Adults) || 0) +
    (Number(data?.Child) || 0) +
    (Number(data?.Infants) || 0);

  const gatewayName = advancePaymentData?.gateway?.gateway_name;
  const needsAdvancePayment = Boolean(
    advancePaymentData?.requires_payment ||
      advancePaymentData?.requires_security_deposit ||
      advancePaymentData?.next_action === "SECURITY_DEPOSIT_AUTH" ||
      advancePaymentData?.next_action === "FLASH_OFFER_PAYMENT"
  );
  const showStripeForm =
    needsAdvancePayment && (gatewayName || "stripe").toLowerCase() === "stripe";

  return (
    <React.Fragment>
      {/* <Typography variant="h6" gutterBottom>
        Brand Name
      </Typography> */}
      <Grid container spacing={2} className="d-flex justify-content-start">
        <Grid item xs={12} sm={12}>
          <Typography variant="h6" gutterBottom sx={{ mt: 2 }} align="left">
            Reservation summary
          </Typography>

          <Grid item xs={12}>
            <Typography gutterBottom align="left" fontSize={"12px"}>
              {data.Date ? moment(data.Date).format("ddd, D MMM YYYY") : ""}
              {" "}
              {data.Time && moment(data.Time, ["HH:mm", "H:mm"], true).isValid()
                ? moment(data.Time, ["HH:mm", "H:mm"]).format("h:mm A")
                : data.Time || ""}
            </Typography>
          </Grid>

          <List disablePadding>
            <ListItem sx={{ py: 0, px: 0 }} className="grey">
              <Typography variant="body2" fontSize={"12px"}>
                {data?.Adults}{" "}
              </Typography>
              &nbsp;x&nbsp;
              <Typography variant="body2" fontSize={"12px"}>
                Adults
              </Typography>
            </ListItem>
            <ListItem sx={{ py: 0, px: 0 }} className="grey">
              <Typography variant="body2" fontSize={"12px"}>
                {data?.Child}{" "}
              </Typography>
              &nbsp;x&nbsp;
              <Typography variant="body2" fontSize={"12px"}>
                Child
              </Typography>
            </ListItem>
            <ListItem sx={{ py: 0, px: 0 }} className="grey">
              <Typography variant="body2" fontSize={"12px"}>
                {data?.Infants}{" "}
              </Typography>
              &nbsp;x&nbsp;
              <Typography variant="body2" fontSize={"12px"}>
                Infants
              </Typography>
            </ListItem>
          </List>
          {data?.SeatingPreference && (
            <Typography
              variant="body2"
              fontSize={"12px"}
              align="left"
              sx={{ mt: 0.5 }}
            >
              Seating: {data.SeatingPreference}
            </Typography>
          )}
          <hr />
          {/* <Typography variant="h6" gutterBottom sx={{ mt: 2 }} align='left'>
            Reservation under
          </Typography> */}
          <Typography align="left" variant="body1" fontSize={"14px"}>
            {data?.FirstName}&nbsp;{data?.LastName}
          </Typography>
          <Typography variant="body1" fontSize={"13px"} align="left">
            {data?.Phone}
          </Typography>
          <Typography variant="body1" fontSize={"13px"} align="left">
            {data?.Email}
          </Typography>
          <hr />

          {/* <Typography gutterBottom>{addresses.join(', ')}</Typography> */}
        </Grid>
      </Grid>


      <Grid container spacing={2}>
        <Grid item xs={12} sm={12}>
          <Typography gutterBottom align="left" variant="body1" fontSize={"14px"}>
            {data?.Requests}
          </Typography>
        </Grid>
      </Grid>
      {loadingAdvanceConfig && (
        <Box sx={{ display: "flex", justifyContent: "center", py: 2 }}>
          <CircularProgress size={24} />
        </Box>
      )}

      {!loadingAdvanceConfig && needsAdvancePayment && (
        <>
          <ChargesSummary
            advancePaymentData={advancePaymentData}
            totalGuests={totalGuests}
            currencySymbol={currencySymbol || "₹"}
          />
          {showStripeForm ? (
            <StripePaymentSection onReady={onStripeReady} />
          ) : null}
        </>
      )}
    </React.Fragment>
  );
}
